import { useEffect, useState } from "react";
import { InitialPallets } from "../../interfaces/intakes.reports";
import { isOneOrMore } from "../../helpers/numberActions";

interface Props {
    setPallets: React.Dispatch<React.SetStateAction<InitialPallets[]>>
    pallet: InitialPallets
}

export const PalletComments = ({ pallet, setPallets }: Props) => {

    const [newComments, setNewComments] = useState<string>("")

    // const hasUnripe = isOneOrMore(pallet.pallgrow.major?.find(defect => defect.name === "unripe")?.value) || isOneOrMore(pallet.pallgrow.minor?.find(defect => defect.name === "unripe")?.value)

    useEffect(() => {
        // const prevCommets = hasUnripe ? "A % of unripe fruit has been detected, nevertheless the outcome of the quality report, there could be a risk for rejection by the client \n\n" : "";
        // setNewComments(`${prevCommets}${pallet.comments || ""}`)
        setNewComments(pallet.comments || "")
    }, [ pallet.comments ])

    const handleComments = (e: React.ChangeEvent<HTMLTextAreaElement>) => {

        setPallets(pallets => pallets.map(pall => {
            if (pall.pid === pallet.pid) {
                return {
                    ...pall,
                    comments: e.target.value
                }
            }
            return pall
        }))
    }

    return (
        <form className="pallet-comments">
            <div className="mb-05">
                <p className='mb-05 bold'>Pallet comments</p>
                <textarea onChange={handleComments} name="comments" className="comments-report" cols={30} rows={3} defaultValue={newComments} />
            </div>
        </form>
    )
}
